
import { defineComponent, onMounted, ref, reactive, onBeforeMount } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useToast } from "vue-toastification";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

import DetailSchool from "@/components/1crm/sekolah/detail-sekolah.vue";
import FeatureList from "@/components/1crm/fitur/management-fitur-sekolah/featureList.vue";
import { checkAuth } from "@/core/config/custom";
import SubscriptionList from "@/components/1crm/fitur/management-fitur-sekolah/subscriptionList.vue";

interface items {
  index: boolean;
  featureList: boolean;
  subsList: boolean;
}

export default defineComponent({
  name: "Detail Sekolah",
  components: {
    DetailSchool,
    FeatureList,
    SubscriptionList
  },
  data() {
    return {
      isShow: true,
      isShowPenggunaanFitur: true,
    };
  },

  beforeMount() {
    this.isShow = !checkAuth(
      JSON.parse(localStorage.getItem(`user_account`)!).role,
      [`MARKETING_LEADER`, `MARKETING_MEMBER`]
    );
    console.log("this.isShow", this.isShow);

    this.isShowPenggunaanFitur = !checkAuth(
      JSON.parse(localStorage.getItem(`user_account`)!).role,
      [`ADMIN_LEGAL`, `CS_LEADER`, `CS_MEMBER`]
    );
  },

  setup() {
    const submitButton = ref<HTMLElement | null>(null);
    const toast = useToast();
    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    let items = reactive<items>({
      index: true,
      featureList: false,
      subsList: false,
    });

    const toggleIndex = () => {
      items.index = true;
      items.featureList = false;
      items.subsList = false;
    };

    const toggleFeature = () => {
      items.index = false;
      items.featureList = true;
      items.subsList = false;
    };

    const toggleSubscription = () => {
      items.index = false;
      items.featureList = false;
      items.subsList = true;
    };

    onMounted(() => {
      store.dispatch(Actions.VERIFY_AUTH_SEKOLAH);
      setCurrentPageBreadcrumbs("Detail Sekolah", ["Data"]);
    });

    return {
      submitButton,
      toggleIndex,
      items,
      toggleFeature,
      toggleSubscription,
    };
  },
});
